mutation DeletePlatformPages($ids: [ID!]!) {
  deletePlatformPages(ids: $ids) {
    id
  }
}

